import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import InputGroupText from "react-bootstrap/InputGroupText";

const TextFilter = ({
  value, onChange,
  append, prepend, errorMessage,
  ...otherProps
}) => {

  // Size
  const getBootstrapSize = () => {
    return "sm";
  }
  // End Size

  const onUpdate = (value) => {
    if (typeof onChange === "function") {
      onChange(value);
    }
  }

  const renderInput = () => {
    return (
      <Form.Control
        {...otherProps}
        isInvalid={!!errorMessage}
        onChange={e => onUpdate(e.target.value)}
        type="text"
        value={value}
      />
    );
  }

  const renderAccessory = (prop) => {
    if (prop) {
      return (
        <InputGroupText>{prop}</InputGroupText>
      );
    }
  }

  return (
    <InputGroup size={getBootstrapSize()} className="flex-nowrap">
      {renderAccessory(prepend)}
      {renderInput()}
      {renderAccessory(append)}
    </InputGroup>
  );

}

export default TextFilter;
